/**
 * DUPLICATE QUESTIONS
 * Pure rule : two cards (topics) of a questionnaire should not ask the same primary question.
 * Only the primary questions are compared : secondary questions are often repeated on purpose (ex : "Commentaire(s)").
 */

interface DuplicateQuestion {
  id: string
  draft?: boolean
  name?: { [language: string]: string }
}

interface DuplicateTopic {
  id: string
  questionPrimary: DuplicateQuestion | null
}

function normalize(label: string): string {
  return label.normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\s+/g, " ").trim().toLowerCase()
}

//Primary questions with the same text (inside a language), grouped. The first topic of each group is the one to open.
export function getDuplicatePrimaryQuestions(
  topics: DuplicateTopic[],
  languages: string[]
): { language: string; label: string; topicIds: string[] }[] {
  const result: { language: string; label: string; topicIds: string[] }[] = []

  languages.forEach((language) => {
    const groups: { [normalized: string]: { label: string; topicIds: string[] } } = {}
    topics.forEach((topic) => {
      const question = topic.questionPrimary
      if (!question || question.draft) return
      const label = (question.name?.[language] || "").trim()
      const normalized = normalize(label)
      if (!normalized) return
      if (!groups[normalized]) groups[normalized] = { label, topicIds: [] }
      groups[normalized].topicIds.push(topic.id)
    })
    Object.values(groups)
      .filter((group) => group.topicIds.length > 1)
      .forEach((group) => result.push({ language, ...group }))
  })

  return result
}
